export const NODE_NAME = 'text';
